import axios, {AxiosResponse} from "axios";
import { Toast } from 'antd-mobile'
import {isEmpty} from "@util/index";
import { Dialog } from 'antd-mobile'
import store from '@src/util/store'
import { goto } from "@src/route"
let lock = false
axios.interceptors.request.use((config) => {
	return config;
}, (error) => {
	console.error(error)
})
axios.interceptors.response.use((response: AxiosResponse<any>) => {
	if (!isEmpty(response.data.errcode) && response.data.errcode == 1000) {
		return response
	}
	if (!isEmpty(response.data.errcode) && response.data.errcode != 0) {
		if (response.data.errcode == 501 || (response.data.errcode == 1 && (response.data.errmsg.indexOf("登录") != "-1"))) {
			store.removeUser()
			if (!lock) {
				lock = true
				Dialog.alert({
					content: response.data.errmsg,
					onConfirm: () => {
						goto('/loginError')
					},
				})
			}
		}
		throw response.data
	}
	return response
}, async (err) => {
	Toast.show('网络错误')
	return Promise.reject(err)
})



export default axios